import BFBackground from '../../components/BFBackground/BFBackground';
import './MainPage.css';

export default function MainPage() {
    return (
        <div className="main-page">
            <BFBackground />
        </div>
    );
}
